import { useCallback, useState } from 'react';
import type React from 'react';
import cx from 'classnames';
import imageError from 'images/imageError.png';
import type { ImageLoaderProps } from 'app/types/photoGallery.type';
import {
  photoCarouselV2ItemImage,
  photoCarouselV2ItemImageContain,
} from 'app/shared/modules/PhotoCarouselV2/PhotoCarouselV2.styles';
import { noop } from 'lodash';

const ImageLoader: React.FC<ImageLoaderProps> = ({
  onClick = () => noop,
  className,
  altText = '',
  image,
  titleText = '',
  fetchPriority = 'auto',
  isLcpImage = false,
  style,
  loading,
  objectFit = 'cover',
}) => {
  const [hasErrored, setHasErrored] = useState<boolean>(false);

  const handleError = useCallback(() => {
    if (!hasErrored) {
      setHasErrored(true);
    }
  }, [hasErrored]);

  const imageStyleClass = objectFit === 'contain' ? photoCarouselV2ItemImageContain : photoCarouselV2ItemImage;

  return (
    <img
      className={cx('ImageLoader', imageStyleClass, className)}
      src={hasErrored ? imageError : image}
      onClick={onClick}
      onError={handleError}
      alt={altText}
      title={titleText}
      style={style}
      fetchpriority={fetchPriority}
      loading={loading || (isLcpImage ? 'eager' : 'lazy')}
      decoding="async"
    />
  );
};

export default ImageLoader;
